import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { closeOnOutside: { type: Boolean, default: true } }

  connect() {
    // When this popup connects and is already open, close others
    if (this.element.open) {
      this.closeOthers()
    }
  }

  disconnect() {
    clearTimeout(this.closeTimeout)
  }

  toggle(event) {
    // This action is triggered when the details element is toggled
    // Always close others when opening, regardless of close_on_outside setting
    if (this.element.open) {
      this.closeOthers()
    }
  }

  closeOthers() {
    // Close other open popups, but leave the ancestor/descendant chain intact
    // so nested dropdowns don't collapse their own parent.
    const openPopups = document.querySelectorAll('details.dropdown[open]')
    openPopups.forEach(popup => {
      if (popup === this.element) return
      if (popup.contains(this.element)) return // ancestor — keep open
      if (this.element.contains(popup)) return // descendant — closes with us anyway
      popup.open = false
    })
  }

  closeOnFocusOutside({ target }) {
    if (!this.element.open) return
    if (this.element.contains(target)) return
    if (target.matches("main")) return

    this.close()
  }

  closeOnClickOutside({ target }) {
    if (this.element.contains(target)) return

    this.close()
  }

  close() {
    this.element.open = false
  }

  // Close after a short delay so a triggering action (e.g. "✓ Copied")
  // stays visible for a beat before the popup collapses.
  closeDelayed() {
    this.closeTimeout = setTimeout(() => this.close(), 700)
  }
}
